export enum ModuleTypes {
  All = 'all',
  Quiz = 'quiz',
  Hotspot = 'hotspot',
  Video = 'video',
  Assessment = 'assessment',
  Nrswa = 'nrswa',
}
